import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import {
  addNewDockageFeeData,
  deleteDockageFee,
  fetchDockageFeeDatas,
  updateDockageFee,
} from "../thunks/dockageFeeThunks";

import type { Fee } from "../../utils/types/dockageFee";

interface DockageFeeListState {
  dockageFeeList: Fee[];
  loading: boolean;
  error: string | null;
  isDataFetched?: boolean;
}

const initialState: DockageFeeListState = {
  dockageFeeList: [],
  loading: false,
  error: null,
  isDataFetched: false,
};

export const dockageFeeListSlice = createSlice({
  name: "dockageFee",
  initialState,
  reducers: {
    resetDataFetched: (state) => {
      state.isDataFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDockageFeeDatas.pending, (state) => {
        state.loading = true;
        state.isDataFetched = true;
      })
      .addCase(fetchDockageFeeDatas.fulfilled, (state, action) => {
        state.dockageFeeList = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchDockageFeeDatas.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });

    builder
      .addCase(updateDockageFee.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDockageFee.fulfilled, (state, action) => {
        state.loading = false;
        state.dockageFeeList = state.dockageFeeList.map((fee) => {
          if (fee.dockageFeeId === action.payload?.dockageFeeId) {
            return { ...fee, ...action.payload };
          }
          return fee;
        });
      })
      .addCase(updateDockageFee.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(deleteDockageFee.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDockageFee.fulfilled, (state, action) => {
        state.loading = false;
        state.dockageFeeList = state.dockageFeeList.filter(
          (fee) => fee.dockageFeeId !== action.payload?.id
        );
      })
      .addCase(deleteDockageFee.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addNewDockageFeeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewDockageFeeData.fulfilled, (state, action) => {
        state.loading = false;
        state.dockageFeeList = [action.payload, ...state.dockageFeeList];
      })
      .addCase(addNewDockageFeeData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
    addWebSocketCases(builder, "dockageFee", "dockageFeeList");
  },
});

export const { resetDataFetched } = dockageFeeListSlice.actions;
export default dockageFeeListSlice.reducer;
